import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { PropType, computed, Ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { InspectionGroup, GetInspectionGroupData } from '@/entities/inspection-group/types';

import { useForm } from '@/core/hooks/forms';
import {
  useDeleteInspectionGroupMutation,
  useGetInspectionGroupQuery,
} from '@/entities/inspection-group/hooks';

import {
  NkStack,
  NkGroup,
  NkButton,
} from '@/core/components';
import { ElAlert, ElNotification } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionGroupDeleteForm',
  props: {
  id: {
    type: Number as PropType<InspectionGroup['id']>,
    default: null,
    required: true,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n();
const router = useRouter();


const { onSubmitted } = useForm(emit);



const queryData = computed(() => ({
  id: props.id,
}));

const {
  data: inspectionGroup,
  isLoading: isInspectionGroupLoading,
} = useGetInspectionGroupQuery(queryData);

const redirectAfterDelete = computed(() => {
  if (inspectionGroup.value?.device)
    return { name: 'visionair-device', params: { device: inspectionGroup.value.device } };

  return { name: 'visionair' };
});


const {
  mutateAsync,
  isLoading,
  isError,
  error: deleteInspectionGroupError,
} = useDeleteInspectionGroupMutation();

const { error } = useFormErrorMessageHandler(deleteInspectionGroupError);

const submit = () => {
  if (!isLoading.value) {
    mutateAsync(
      { id: queryData.value.id },
      {
        onSuccess: () => ElNotification({
          type: 'success',
          position: 'bottom-right',
          message: t('inspection-group.notification.delete.message'),
          title: t('inspection-group.notification.delete.title'),
        }),
      },
    ).then((data) => {
      onSubmitted(data);
      router.push(redirectAfterDelete.value);
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(ElAlert), {
        type: "error",
        effect: "dark",
        title: _ctx.$t('inspection-group.form.delete.confirmation'),
        closable: false
      }, null, 8, ["title"]),
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
            type: "danger",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.form.delete.button')), 1)
            ]),
            _: 1
          })), [
            [_directive_loading, _unref(isLoading)]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(isInspectionGroupLoading)]
  ])
}
}

})